"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthServer = exports.JWTServer = void 0;
exports.JWTServer = 'https://auth.manifoldxyz.dev';
exports.OAuthServer = 'https://oauth2.manifoldxyz.dev';
